import { getEvenNumbersBetween, getNumbersBetween } from '@core/utils/number';

import { GeneticSex, HealthHistoryQuestionnaireKey } from './health-history';
import { HealthHistoryQuestionOption } from './question';

export const kidsWaistCircumferenceOptions: HealthHistoryQuestionOption[] = getEvenNumbersBetween(2, 14).map(
  (size) => ({
    label: 'Health_History.Waist_Circumference.Kids_Size',
    labelValue1: size,
    value: size,
    triggeredBy: HealthHistoryQuestionnaireKey.GeneticSex,
    triggeredByValues: [GeneticSex.Male, GeneticSex.Female]
  })
);

const womensWaistSizes = [
  { size: '00', inches: 24 },
  { size: '0', inches: 25 },
  { size: '2', inches: 26 },
  { size: '4', inches: 27 },
  { size: '6', inches: 28 },
  { size: '8', inches: 29 },
  { size: '10', inches: 30 },
  { size: '12', inches: 31.5 },
  { size: '14', inches: 33 },
  { size: '16', inches: 34.5 },
  { size: '18', inches: 36 },
  { size: '20', inches: 38.5 },
  { size: '22', inches: 40 },
  { size: '24', inches: 41.5 },
  { size: '26', inches: 43 },
  { size: '28', inches: 44.5 },
  { size: '30', inches: 46 }
];

export const womensWaistCircumferenceOptions: HealthHistoryQuestionOption[] = womensWaistSizes.map((waistSize) => ({
  label: 'Health_History.Waist_Circumference.Womens_Size',
  labelValue1: waistSize.size,
  labelValue2: waistSize.inches,
  value: waistSize.inches,
  triggeredBy: HealthHistoryQuestionnaireKey.GeneticSex,
  triggeredByValues: [GeneticSex.Female]
}));

export const mensWaistCircumferenceOptions: HealthHistoryQuestionOption[] = getNumbersBetween(26, 62).map((size) => ({
  label: 'Health_History.Waist_Circumference.Mens_Size',
  labelValue1: size,
  value: size,
  triggeredBy: HealthHistoryQuestionnaireKey.GeneticSex,
  triggeredByValues: [GeneticSex.Male]
}));

export const waistCircumferenceOptions: HealthHistoryQuestionOption[] = [
  ...kidsWaistCircumferenceOptions,
  ...womensWaistCircumferenceOptions,
  ...mensWaistCircumferenceOptions
];
